import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-100">
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 桃花影院免费观看`}
          className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-2">{movie.description}</p>
        </div>
        {movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-white whitespace-nowrap">
            新
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-white whitespace-nowrap">
            热播
          </span>
        )}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded px-2 py-0.5">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-white text-xs font-medium">{movie.rating}</span>
        </div>
      </div>
      <div className="mt-2 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-400 mt-0.5">{movie.updateInfo}</p>
      </div>
    </Link>
  );
}